import React, { useContext } from 'react'
import { Tabs, Tab } from '@mui/material'
import { Link } from 'react-router-dom'
import qs from 'qs'

import { AuthContext } from 'contexts/auth'
import { Permissions } from 'api'
import { FETCH_CALENDAR_PREFERENCE } from 'state/calendarPreference/actions'
import { FETCH_FOLLOW_UP_LABELS } from 'state/customFollowUpLabels/actions'

type Props = {
  currentTab: string;
};

type TabConfig = {
  label: string;
  value: string;
  permission?: string;
};

export const TABS = [
  {
    label: 'Program Calendar',
    value: 'calendar-subscriptions',
    permission: FETCH_CALENDAR_PREFERENCE
  },
  {
    label: 'Custom Follow-up Labels',
    value: 'custom-follow-up-labels',
    permission: FETCH_FOLLOW_UP_LABELS
  },
  {
    label: 'Email Notifications',
    value: 'email-notifications'
  },
  {
    label: 'General',
    value: 'general'
  },
  {
    label: 'Account',
    value: 'accounts'
  },
] as const

const UserPreferenceTabs = ({
  currentTab,
}: Props) => {
  const query = qs.parse(window.location.search.substring(1))
// @ts-expect-error - TS2339 - Property 'split' does not exist on type 'string | string[] | ParsedQs | ParsedQs[]'.
  const tabFilter = (query && query.tabFilter) ? query.tabFilter.split() : undefined
// @ts-expect-error - TS2339 - Property 'authorization' does not exist on type 'unknown'.
  const { authorization } = useContext(AuthContext)
  const enabledTabs = TABS.filter(
    ({
      permission = '',
      value,
    }: TabConfig) => {
      if (Array.isArray(tabFilter) && !tabFilter.includes(value)) {
        return false
      }

      if (!permission) {
        return true
      }

      if (Permissions.isOperationPermitted(authorization, permission)) return true

      return false
    }
  )

  return (
    <Tabs indicatorColor='primary' value={currentTab}>
      {
        enabledTabs.map(
          ({ label, value }) => (
            <Tab
              key={value}
              value={value}
              label={label}
              component={Link}
              to={`/preferences/${value}`}
            />
          )
        )
      }
    </Tabs>
  )
}

export default UserPreferenceTabs
